import React, { Component } from 'react';
import logo from '../assets/logo.svg';


import Icon from 'react-icons-kit';
import {envelopeO} from 'react-icons-kit/fa/envelopeO'
import {phone} from 'react-icons-kit/fa/phone'

import { NavBar, NavBarMobile, NavFlags} from './NavBar'
import navigation from '../navigation'
import { layoutGenerator } from 'react-break'
import {NavLink} from 'react-router-dom'
import Session from '../services/session';


//import './App.css';

import Sticky from 'react-sticky-el';
import {Row, Col, Container, PureGridProvider} from '../3rdparty/react-pure-grid';

//import model from '../model.json'
import i from '../imports';


const layout = layoutGenerator({
  mobile: 0,
  phablet: 550,
  tablet: 768,
  desktop: 1200,
});
 
const OnMobile = layout.is('mobile');
const OnAtLeastTablet = layout.isAtLeast('tablet');
const OnAtMostTablet = layout.isAtMost('tablet');
const OnAtMostPhablet = layout.isAtMost('phablet');
const OnDesktop = layout.is('desktop');

const LeftSide = () => (
    <div>
      <OnDesktop>
      <NavLink style={{textDecoration: 'none', color: 'black'}} to={`/${Session.language}/`}>
        <Row align="end" style={{ paddingTop: 40}}>
          <Col xs={2} align='right' style={{paddingRight: '10px'}}>
            <img src={logo} width={46} minWidth={20} alt="logo" />
          </Col>
          <Col xs={10} align='left' style={{paddingLeft: 0}}>
            <h1 style={{fontSize: 32, fontWeight: 'bold', margin: 0}}>TicketGroup Russia</h1>
          </Col>
        </Row>
      </NavLink>
      </OnDesktop>
      <OnAtMostTablet>
        <NavLink style={{textDecoration: 'none', color: 'black'}} to={`/${Session.language}/`}>
          <Row align="end" style={{ paddingTop: 10, paddingBottom: 0 }}>
            <Col xs={1} md={1} align='right' style={{marginRight: 0}}>          
                <img src={logo} width={30} minWidth={20} alt="logo" />
            </Col>
            <Col xs={11} md={11} align='left' style={{paddingLeft: 0}}>
              <h1 style={{fontSize: 30, fontWeight: 'bold', margin: 0}}>TicketGroup Russia</h1>
            </Col>
          </Row>
        </NavLink>
        
        <Row justify='right' style={{marginBottom: 10}}>
          <Col xs={12} sm={12}><Contact style={{fontSize: 16, color: 'grey'}} contact={Session.model.common.email} icon={envelopeO}/></Col>
          <Col xs={12} sm={12}><Contact style={{fontSize: 16, color: 'grey'}} contact={Session.model.common.contacts.phones[0].phone} icon={phone}/></Col>
        </Row>
        
      </OnAtMostTablet>
      </div>
)

const Contact = (props) => (
    <span>
      <OnDesktop>
          <Row align='center' justify='end'>
            <Col xs={11} align={'right'} style={props.style? props.style : {fontSize: 20}}>
              {props.contact}
            </Col>
            <Col xs={1} align={'right'}>
              <Icon style={{marginTop: 5}} icon={props.icon}/>
            </Col>
          </Row>
      </OnDesktop>
      <OnAtMostTablet>
          <Row align='center' justify='end'>
            
            <Col xs={1} align={'right'}>
              <Icon style={{marginTop: 5, marginRight: 5, color: 'grey'}} icon={props.icon}/>
            </Col>
            <Col xs={11} align={'left'} style={props.style? props.style : {fontSize: 20}}>
              {props.contact}
            </Col>

          </Row>

        </OnAtMostTablet>
    </span>
)

const RightSide = () => (
    <div>
      <Row align='start'>
        <Col>
            <NavFlags />
        </Col>
      </Row>
      <Row align='end' justify='end' style={{color: 'grey', paddingTop: 20}}>
          <Col xs={12} md={12}>
            <Contact contact={Session.model.common.email} icon={envelopeO}/>
            <Contact contact={Session.model.common.contacts.phones[0].phone} icon={phone}/>
          </Col>
      </Row>
    </div>
)




class Header extends Component {

  render() {
    const language = Session.language;
    navigation.map( n => n.text = Session.model.navigation[n.name]);

    return (
      <span>
        <Sticky style={{zIndex: 999, position: "fixed", width: "100%"}} positionRecheckInterval={5} >
          <PureGridProvider maxWidth={'auto'} gutterSize={0}>
            <Container className='animated fadeIn' style={{ backgroundColor: 'white' }} fluid={true} >
              <Row align="start" className='q-nav-line'>
                <Col md={12} lg={2} style={{marginRight: '-300px'}} >
                  <LeftSide />
                </Col>
                <OnDesktop>
                  <Col lg={8} align="center" >
                    <Row align='end' justify='end'>
                      <Col>
                        {/* <Row align='start'>
                          <Col>
                              <div style={{height:"84px"}}></div>
                          </Col>
                        </Row> */}
                        <Row align='end' justify='end' style={{paddingTop: 84}} >
                            <Col>
                              <NavBar items= { navigation } />
                            </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </OnDesktop>
                <OnDesktop>
                  <Col md={12} lg={2} align='right' style={{paddingRight: 20, marginLeft: '-170px'}}>
                    <RightSide />
                  </Col>
                </OnDesktop>
              </Row>
            </Container>
          </PureGridProvider>
        </Sticky>

      <OnAtMostTablet>
        <NavBarMobile items = { navigation }/>
      </OnAtMostTablet>
    </span>

    );
  }
}

//import React from 'react';

const TheList = ( ) => {
  let result = [];
  for (let i = 0; i < 100; i++ )
  { result.push(
    <p className="App-intro">
    To get started, edit <code>src/App.js</code> and save to reload.
    sdiohdofihdsoih
    dsiofuhosdhf
    </p>);
  }

  return ( result );
}



export default Header;